import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const fetchReporting = createAsyncThunk("reporting/fetchReporting", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reporting/allReporting", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },

    body: JSON.stringify(action)
  });
  const reporting = await response.json();
  return reporting;
});


export const deleteReporting = createAsyncThunk("reporting/deleteReporting", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reporting/deleteReporting/" + action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const reporting = await response.json();
  return reporting;
});

export const fetchAllreporting = createAsyncThunk("reporting/fetchAllreporting", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reporting/fetchAllreporting", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body: JSON.stringify(action)
  });
  const reporting = await response.json();
  return reporting;
});

export const reportingGetById = createAsyncThunk("reporting/reportingGetById", async (id1) => {
  const  id  = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "reporting/getReporting", {
    method: 'POST',
    headers: {
      'id':id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
  
  });
  const reporting = await response.json();
  return reporting;
});
 
export const reportingLigneGetById = createAsyncThunk("reporting/reportingLigneGetById", async (id1) => {
  const  id  = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "reporting/reportingLigneGetById", {
    method: 'POST',
    headers: {
      'id':id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
  
  });
  const reporting = await response.json();
  return reporting;
});
export const reportingAdded = createAsyncThunk("reporting/addReporting", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reporting/addReporting", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body: JSON.stringify(action)
  });
  const reporting = await response.json();
  return reporting;
});
const reportingReduce = createSlice({
  name: "reporting",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    /* reportingAdded(state, action) {
      fetch(Configuration.BACK_BASEURL + "reporting/addReporting", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
        body: JSON.stringify(action.payload)
      });
    }, */

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReporting.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchReporting.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchReporting.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(reportingGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(reportingGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(reportingGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },
  
});

/* export const { reportingAdded } = reportingReduce.actions; */

export default reportingReduce.reducer;
